export default {
      id: "magnifying-glass-usage",
      viewBox: "0 0 20.647 20.647",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#magnifying-glass",
      toString: function () {
        return this.url;
      }
    }